import React from "react";
import styled from "styled-components";

const SuggestionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const Suggestion = styled.button`
  background-color: ${({ theme }) => theme.colors.verae[50]};
  border: 1px solid transparent;
  border-radius: 20px;
  padding: 0.25rem 0.75rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.verae[100]};
  }
`;

interface SearchSuggestionsProps {
  deviceTypes: string[];
  serialNumbers: string[];
  onSuggestionClick: (suggestion: string) => void;
}

export const SearchSuggestions: React.FC<SearchSuggestionsProps> = ({
  deviceTypes,
  serialNumbers,
  onSuggestionClick,
}) => {
  return (
    <SuggestionsContainer>
      {/* {deviceTypes.slice(0, 3).map((type) => (
        <Suggestion
          key={`type-${type}`}
          onClick={() => onSuggestionClick(type)}
        >
          {type}
        </Suggestion>
      ))} */}
      {serialNumbers.slice(0, 2).map((serial) => (
        <Suggestion
          key={`serial-${serial}`}
          onClick={() => onSuggestionClick(serial)}
        >
          S/N: {serial}
        </Suggestion>
      ))}
    </SuggestionsContainer>
  );
};
